import { Select } from '@/components/Select';

/**
 * Objective selector for the combination report.
 *
 * Chart export is gone with the chart: the report is a table of conversions, order value and
 * interaction, and there is no time series to export. Currency is not offered either, since
 * conversions are counted whatever they were paid in and the only currency-scoped figure,
 * revenue, is shown alongside its own order value.
 */
type SelectorsProps = {
  goals: readonly string[];
  goal: string;
  setGoal: (goal: string) => void;
};

export const Selectors = ({ goals, goal, setGoal }: SelectorsProps) => (
  <div className="bg-panel border-line rounded-panel flex flex-wrap items-end gap-4 border px-3 py-2.5">
    <label className="space-y-1.5">
      <span className="micro-label block">Objective</span>
      <Select
        options={goals.map((g) => ({ value: g, label: g }))}
        value={goal}
        onValueChange={setGoal}
        placeholder="Select objective"
        className="border-line bg-field h-8 w-44 rounded-lg text-meta"
      />
    </label>
  </div>
);
